var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.item && _vm.item.lessonplan.classbook)?_c('pdf-reader',{attrs:{"src":_vm.item.lessonplan.classbook.url},model:{value:(_vm.pdfLoad),callback:function ($$v) {_vm.pdfLoad=$$v},expression:"pdfLoad"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }